export const featuredTestimonials = [
  {
    initials: 'MK',
    text: 'Zaoszczędziłem mnóstwo czasu. W poniedziałek wszedłem na salę w pełni przygotowany, bez nerwowego kombinowania. Polecam z całego serca.',
    author: 'Marek K.',
    role: 'Trener funkcjonalny · Warszawa',
    bg: 'bg-blue-600',
  },
  {
    initials: 'AW',
    text: 'Przed zakupem miałam wątpliwości, ale pozytywnie mnie zaskoczył. Dzięki trzem wersjom prowadzę grupy o różnym poziomie bez żadnego stresu.',
    author: 'Agnieszka W.',
    role: 'Instruktorka · Kraków',
    bg: 'bg-cyan-600',
  },
  {
    initials: 'TN',
    text: 'Układam zajęcia w 10 minut i to widać. Za tę cenę polecam bez wahania.',
    author: 'Tomasz N.',
    role: 'Trener boksu · Wrocław',
    bg: 'bg-blue-600',
  },
]

export const coachTestimonials = [
  {
    initials: 'KD',
    name: 'Katarzyna D.',
    location: 'Gdańsk',
    text: 'Kiedyś w poniedziałki przychodziłam wykończona. Teraz otwieram tom i w 5 minut mam gotowe zajęcia.',
    bg: 'bg-blue-600',
  },
  {
    initials: 'PZ',
    name: 'Piotr Z.',
    location: 'Poznań',
    text: 'Kupiłem trochę sceptycznie i byłem w szoku: jest dużo bardziej kompletny, niż się spodziewałem.',
    bg: 'bg-cyan-600',
  },
  {
    initials: 'MS',
    name: 'Magdalena S.',
    location: 'Łódź',
    text: 'Rozgrzewki i zakończenia zajęć uratowały mi skórę. Widać, że każde zajęcia mają strukturę od początku do końca.',
    bg: 'bg-blue-600',
  },
  {
    initials: 'JW',
    name: 'Jakub W.',
    location: 'Katowice',
    text: 'Oszczędza mi masę czasu. Nie tracę już niedziel na układanie sesji. Gorąco polecam.',
    bg: 'bg-cyan-600',
  },
]
